// src/pages/MyBookingPage.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MyProperties from "../components/MyProperties";

const LoginPage = () => {
  return (
    <>
      <Header />
      <MyProperties />
      <Footer />
    </>
  );
};

export default LoginPage;
